export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/ar-eg.lyaml"));
at({ "ar-eg": { "public": { "sampleString": "\u0633\u0644\u0633\u0644\u0629 \u0646\u0645\u0648\u0630\u062C\u064A\u0629" } } });
};